module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction"
  }, [_c('div', {
    staticClass: "ground"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "introduction-cont"
  }, [_c('div', {
    staticClass: "introduction-cont-cell",
    attrs: {
      "data-id": "/enceinte"
    },
    on: {
      "click": _vm.clickChoice
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "introduction-cont-cell",
    attrs: {
      "data-id": "/enfants"
    },
    on: {
      "click": _vm.clickChoice
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "introduction-cont-cell",
    attrs: {
      "data-id": "/couple"
    },
    on: {
      "click": _vm.clickChoice
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "introduction-plane",
    attrs: {
      "src": require("./../assets/plane.svg"),
      "width": "120"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("1")]), _c('span', [_vm._v("Choisissez votre profil :")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction-cont-cell-img"
  }, [_c('img', {
    staticClass: "introduction-img",
    attrs: {
      "src": require("./../assets/femme_enceinte.png"),
      "width": "154"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction-cont-cell-text"
  }, [_c('span', [_vm._v("Femme enceinte")]), _vm._v(" "), _c('span', {
    staticClass: "introduction-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction-cont-cell-img"
  }, [_c('img', {
    staticClass: "introduction-img",
    attrs: {
      "src": require("./../assets/homme_enfants.png"),
      "width": "220"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction-cont-cell-text"
  }, [_c('span', [_vm._v("Adulte avec de jeunes enfants")]), _vm._v(" "), _c('span', {
    staticClass: "introduction-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction-cont-cell-img"
  }, [_c('img', {
    staticClass: "introduction-img",
    attrs: {
      "src": require("./../assets/couple.png"),
      "width": "240"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduction-cont-cell-text"
  }, [_c('span', [_vm._v("Couple")]), _vm._v(" "), _c('span', {
    staticClass: "introduction-triangle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a956f908","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/0-Introduction.vue
// module id = 118
// module chunks = 1